import { Injectable, NgZone } from '@angular/core';
import { ActivatedRouteSnapshot, RouterStateSnapshot, UrlTree, Router } from '@angular/router';
import { Observable, of } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { MatSnackBar } from '@angular/material/snack-bar';
import { AuthService } from './auth.service';

@Injectable({
  providedIn: 'root'
})
export class AuthGuard  {
  storedToken;
  refreshedUser;
  constructor(private authService: AuthService,
     private ngZone: NgZone, private router: Router, private snackBar: MatSnackBar) {
  }


  isExpiredToken(claims: any) {
    const auth_time = claims.auth_time ? claims.auth_time : claims.expiration;
    const d = new Date().getTime() / 1000;
    if (d - auth_time >= 3600) {
      return true;
    }
    return false;
  }

  goToLogin() {
    this.router.navigate(['login']);
  }

  goToHome() {
    this.ngZone.run(() => {
      this.router.navigate(['']);
    })
  }

  openSnackBar(message: string, action: string) {
    this.snackBar.open(message, action, {
      duration: 2000
    });
}

  canActivate(
  next: ActivatedRouteSnapshot,
  state: RouterStateSnapshot
): Observable<boolean> {

  const url: string = state.url;
  const token = this.authService.getToken();

  if (!token) {
    this.authService.redirectUrl = url;
    this.goToLogin();
    return of(false);
  }

  return this.authService.tokenHandler(token).pipe(
    map(e => {
      if (e && e.length === 2) {
        this.openSnackBar(e[0], 'close');
        this.goToLogin();
        return false;
      }

      if (e && this.isExpiredToken(e)) {
        this.openSnackBar('Session expired !', 'close');
        this.goToLogin();
        return false;
      }

      if (e && e.email) {
        this.authService.setUser(e);
        return true;
      }

      this.authService.redirectUrl = url;
      this.goToLogin();
      return false;
    }),
    catchError(() => {
      this.authService.redirectUrl = url;
      this.goToLogin();
      return of(false);
    })
  );
}
}
